import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Card,
  CardBody,
  Collapse,
  FormGroup,
  Input,
  Label
} from 'reactstrap'
import { FormattedMessage } from 'react-intl'

import arrow from './images/arrow.png'

const LayerItem = styled(FormGroup)`
  &.form-check {
    align-items: center;
    display: flex;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
    width: 100%;
  }
`

const CollapseButton = styled.div.attrs({
  rotate: ({ isOpen }) => isOpen ? '0' : '180'
})`
  background: url(${arrow}) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  height: 1rem;
  margin-left: auto;
  transform: rotate(${({ rotate }) => rotate}deg);
  width: 1rem;
`
const ItemCardBody = styled(CardBody)`
 &.span {
  color: black !important; 
 }
`

const renderHr = isOpen => {
  if (!isOpen) { return <hr /> }
}

class ResultLayerItem extends PureComponent {
  constructor () {
    super()

    this.state = {
      isOpen: false
    }

    this.onToggle = this.onToggle.bind(this)
  }

  onToggle () {
    const { isOpen } = this.state

    this.setState({
      isOpen: !isOpen
    })
  }

  render () {
    const { isOpen } = this.state
    const { item, onSelect, selected } = this.props

    return ([
      <LayerItem check>
        <Label check>
          <Input
            type='checkbox'
            data-key={item.nm_layer}
            onChange={onSelect}
            value={selected} /> <FormattedMessage id={ `name.layer.${ item.id_layer }` } />
        </Label>
        <CollapseButton onClick={this.onToggle} isOpen={isOpen} />
      </LayerItem>,
      <Collapse isOpen={isOpen}>
        <Card>
          <ItemCardBody className="layer-card-text">
            <FormattedMessage id={ `metadata.layer.${ item.id_layer }` } />
          </ItemCardBody>
        </Card>
      </Collapse>,
      renderHr(isOpen)
    ])
  }
}

ResultLayerItem.propTypes = {
  item: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.string
}

export default ResultLayerItem



// WEBPACK FOOTER //
// ./src/components/atoms/ResultLayerItem/ResultLayerItem.js